import { render, staticRenderFns } from "./DragDropImage.vue?vue&type=template&id=78bf5548&"
import script from "./DragDropImage.vue?vue&type=script&lang=js&"
export * from "./DragDropImage.vue?vue&type=script&lang=js&"
import style0 from "./DragDropImage.vue?vue&type=style&index=0&id=78bf5548&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports